// extracted by mini-css-extract-plugin
module.exports = {"container":"Counter_container__dvExN","title":"Counter_title__UR7ZD","subtitle":"Counter_subtitle__pdo9Z","counterWrapper":"Counter_counterWrapper__pEy3V"};